import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import useUserProvider from "@/core/dataProviders/providers/auth/useUserProvider";
import useUserSubscriptionProvider from "@/core/dataProviders/providers/auth/useUserSubscriptionProvider";
import { format } from "date-fns";
import { cs } from "date-fns/locale";
import { useAuthUrls } from "@/hooks/useAuthUrls";
import { ButtonType } from "@/types/ui-kit/buttons";
import { BaseButton } from "@/components/ui-kit/Buttons/BaseButton";
import { User } from "@/connectors/remp/types/rempTypes";
import { pushToDataLayer } from "@/utils/pushToDataLayer";
import { AccountNavigationProps } from "@/types/layout";

export const AccountNavigation: React.FC<AccountNavigationProps> = ({ postId }) => {
  const [hoverTitle, setHoverTitle] = useState<boolean>(false);
  const [activeUser, setActiveUser] = useState<User | null | undefined>(null);
  const [user] = useUserProvider();
  const [subscriptions] = useUserSubscriptionProvider();
  const { getSubscriptionUrl, getLoginUrl } = useAuthUrls();

  useEffect(() => {
    setActiveUser(user);
  }, [user]);

  return (
    <div className="static border-b border-gray-200 font-condensed text-sm dark:border-white-25 lg:relative">
      <Link
        href={getLoginUrl()}
        className="flex items-center justify-between px-5 py-4 transition-colors ease-in-out hover:bg-gray-100 dark:hover:bg-white-25"
        onMouseEnter={() => setHoverTitle(true)}
        onMouseLeave={() => setHoverTitle(false)}
        onClick={() =>
          pushToDataLayer({
            event: "article_interaction",
            interaction_type: "click_cta",
            interaction_option: user ? "Můj účet" : "Příhlásit / Registrovat",
          })
        }
      >
        <>
          {activeUser === null ? (
            <div className="min-h-[20px]"></div>
          ) : (
            <>
              <div className="mr-5 w-full">
                <p
                  className={`${
                    hoverTitle ? "no-underline underline-offset-1 md:underline" : ""
                  } font-sans text-2xs text-dark dark:text-white`}
                >
                  {user ? "Můj účet" : "Příhlásit / Registrovat"}
                </p>
                {user && (
                  <p className="mb-1 mt-0.5 font-sans text-xs font-light text-dark-70 underline dark:text-white-70">
                    {user.email}
                  </p>
                )}
                {user && !!subscriptions?.length && (
                  <p className="font-sans text-3xs font-light text-dark-50 dark:text-white-70">
                    Predplatné {subscriptions[0].label} platné do{" "}
                    {format(new Date(subscriptions[0].end_at.split(" ")[0]), "dd. M. Y", { locale: cs })}
                  </p>
                )}
              </div>
              <Image
                src="/assets/images/sidebar/arrow-right.svg"
                alt="Bookmark"
                className="h-5 w-2 dark:invert"
                width={20}
                height={20}
              />
            </>
          )}
        </>
      </Link>
      {user && !subscriptions?.length && (
        <div className={`-mt-4 px-4 pb-4 transition-colors ease-in-out ${hoverTitle ? "bg-gray-100" : ""}`}>
          <div className="mt-2 overflow-hidden rounded-full">
            <BaseButton href={getSubscriptionUrl()} title="Chci předplatné" type={ButtonType.PrimaryMd} fullWidth />
          </div>
        </div>
      )}
    </div>
  );
};
